import styles from "./style.module.scss";

const Loader = ({ progress = 0 }: { progress: number }) => {
  const scale = Math.max(0, Math.min(progress / 100, 1));

  return (
    <div
      className={styles.progressContainer}
      style={{ ["--glow-width" as any]: `${scale * 100}%` }}
    >
      <div className={styles.progressBar}>
        <div
          className={styles.progressFill}
          style={{ transform: `scaleX(${scale})` }}
        />
      </div>
    </div>
  );
};

export default Loader;
